/** Курс об'єкта: objectPriceRate / objectPrice. null, якщо колонок недостатньо. */
export const getObjectFx = (
    objectPrice?: number | null,
    objectPriceRate?: number | null,
): number | null => {
    const price = Number(objectPrice || 0);
    const priceRate = Number(objectPriceRate || 0);
    if (price <= 0 || priceRate <= 0) return null;
    return priceRate / price;
};

/** Два знаки після коми, як у сумах. */
export const formatObjectFx = (fx: number): string => {
    if (!Number.isFinite(fx)) return '';
    return fx.toLocaleString('en-US', {
        minimumFractionDigits: 2,
        maximumFractionDigits: 2,
    });
};

/** Борг у локальній валюті за курсом об'єкта, до копійок. */
export const debtAmountInLocal = (debtBase: number, fx: number): number =>
    Math.round(Number(debtBase) * fx * 100) / 100;
